import { GetMethod, PostMethod } from '../../serviceHelper';

const getMethods = (service: 'IntegrationManager', controller: 'Explorer') => ({
	GetExplorerData: new GetMethod<Array<any>, null>({
		service,
		controller,
		method: 'GetExplorerData'
	}),
	GetConnectionElementData: new PostMethod<string, any>({
		service,
		controller,
		method: 'GetConnectionElementData'
	}),
	GetQueryElementData: new PostMethod<string, any>({
		service,
		controller,
		method: 'GetQueryElementData'
	}),
	GetExplorerElementData: new PostMethod<string, any>({
		service,
		controller,
		method: 'GetExplorerElementData'
	}),
	UpdateGroup: new PostMethod<string, any>({
		service,
		controller,
		method: 'UpdateGroup'
	}),
	CreateGroup: new PostMethod<string, any>({
		service,
		controller,
		method: 'CreateGroup'
	}),
	DeleteGroup: new PostMethod<boolean, any>({
		service,
		controller,
		method: 'DeleteGroup'
	})
});

export { getMethods };
